import React, {Component} from 'react';
import {connect} from 'react-redux';
import TeamChecking from './team-checking';
import TeamExposure from './team-exposure';

class StackTeams extends Component {
    render() {
        const {stacking} = this.props;
        const teams = stacking.getActiveTeams();

        return (
            <>
                {Object.keys(teams).map((team) => {
                    return (
                        <div key={team} className="stack-box">
                            <TeamChecking team={team} />
                            <TeamExposure team={team} />
                        </div>
                    );
                })}
            </>
        );
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking} = state;
    return {
        stacking: randomTeamStacking,
    };
}

export default connect(mapStatesToProps)(StackTeams);
